import { twMerge } from 'tailwind-merge';
import { BankSelectItem } from './BankSelectItem';
import type { BankSelectListProps } from './types';

export const BankSelectList = ({
  banks,
  selectedBank,
  onSelect,
  className,
}: BankSelectListProps) => (
  <div className={twMerge('max-h-[532px] bg-white safe-area-bottom overflow-y-auto', className)}>
    <div>
      {banks.map((bank, index) => (
        <BankSelectItem
          key={bank.displayName}
          bank={bank}
          isSelected={selectedBank === bank.displayName}
          onSelect={onSelect}
          className={index === 0 ? 'pt-1' : undefined}
        />
      ))}
    </div>
  </div>
);
